
import { IContractTemplateForm, IDistributionMutation } from 'services/templates/types';
import { separateTemplateTreeItems } from '../templateFormItemsSeparator';

export const channelDistributionTemplateFormToQuery = (
  contract: IContractTemplateForm
): IDistributionMutation | null => {
  const { channelDistribution } = separateTemplateTreeItems(
    contract.items[0].children
  );

  return channelDistribution ?? null;
};
